/*Copyright © SITA INC Ireland, SITA INC USA, SITA Switzerland Sarl 2025. Confidential. All rights reserved.*/
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor() { }

  public setStorageItem(key: string, value: string, isLocalStorage:boolean = true): void {
    isLocalStorage ?  localStorage.setItem(key, btoa(value)) : sessionStorage.setItem(key, btoa(value));
  }

  public getStorageItem(key: string, isLocalStorage:boolean = true){
    let returnedValue  = isLocalStorage ? localStorage.getItem(key): sessionStorage.getItem(key);
    return returnedValue ? atob(returnedValue): returnedValue
  }

  public removeStorageItem(key: string): void {
    localStorage.removeItem(key);
    sessionStorage.removeItem(key);
  }

  public clearStorage(){
    localStorage.clear();
    sessionStorage.clear();
  }

}
